import { Onboarding } from '@/components';

const OnboardingRoute = () => <Onboarding />;

export default OnboardingRoute;
